import React from 'react';
import { OptionCard } from './OptionCard';

const partnerOptions = [
  {
    icon: "💬",
    title: "Social Partners",
    description: "Manage partners for social media campaigns"
  },
  {
    icon: "🎥",
    title: "Video Partners",
    description: "Manage partners for video advertising"
  },
  {
    icon: "🖥️",
    title: "Direct Display Partners",
    description: "Manage partners for display advertising",
    link: "/partners/display"
  }
];

export function SelectPartnersPage() {
  return (
    <main className="main-content">
      <h1 className="page-title">Select Partners</h1>
      
      <div className="options-grid">
        {partnerOptions.map((option, index) => (
          <OptionCard 
            key={index}
            icon={option.icon}
            title={option.title}
            description={option.description}
            link={option.link}
          />
        ))}
      </div>
    </main>
  );
} 